import { inject, Injectable } from '@angular/core';
import { ApiClient } from './api-client';
import { Observable } from 'rxjs';
import { Endpoints } from './endpoints';
import { SHARED_CONFIG } from '../../../environments/shared-config.token';
import { ODataResponse } from '../models/odata/odata-response';
import { OdataQueryOptions } from '../models/odata/odata-query-options';
import { Facility } from '../models/facility/facility';
import { FacilityContact } from '../models/facility/facility-contact';

@Injectable({
  providedIn: 'root',
})
export class SharedFacilityApi {
  private apiClient = inject(ApiClient);
  private config = inject(SHARED_CONFIG);

  getFacilities(odataQueryOptions: OdataQueryOptions): Observable<ODataResponse<Facility>> {
    odataQueryOptions.expand = ['zone', 'address', 'facilityStatus', 'facilityType'];
    odataQueryOptions.count = true;
    const httpParams = odataQueryOptions.toHttpParams();
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.Facility.getFacilities()}`, httpParams);
  }

  findFacilities(odataQueryOptions: OdataQueryOptions): Observable<ODataResponse<Facility>> {
    const httpParams = odataQueryOptions.toHttpParams();
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.Facility.getFacilities()}`, httpParams);
  }

  getFacility(facilityId: number, odataQueryOptions: OdataQueryOptions | null = null): Observable<Facility> {
    if (!odataQueryOptions) {
      odataQueryOptions = new OdataQueryOptions();
      odataQueryOptions.expand = ['zone', 'address', 'contacts', 'golfCourseType', 'facilityType', 'facilityStatus'];
    }
    const httpParams = odataQueryOptions.toHttpParams();
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.Facility.getFacility(facilityId)}`, httpParams);
  }

  createFacility(request: Facility): Observable<Facility> {
    return this.apiClient.post(`${this.config.apiUrl}${Endpoints.Facility.createFacility()}`, request);
  }

  getFacilityContacts(
    facilityId: number,
    odataQueryOptions: OdataQueryOptions,
  ): Observable<ODataResponse<FacilityContact>> {
    const httpParams = odataQueryOptions.toHttpParams();
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.Facility.getFacilityContacts(facilityId)}`, httpParams);
  }

  createFacilityContact(request: FacilityContact): Observable<FacilityContact> {
    return this.apiClient.post(
      `${this.config.apiUrl}${Endpoints.Facility.createFacilityContact(request.facilityId ?? -1)}`,
      request,
    );
  }
}
